import { SelectionType } from '@convergence/types';
import { valueFromTreeAndPath } from './util';
import { AnalysisValueProps } from './types';

export function AnalysisSelection(props: AnalysisValueProps<SelectionType>) {
  let value =
    valueFromTreeAndPath<string>(props.tree, props.propertyPath) ?? '';

  const name = `${props.name}:`;
  return (
    <div className="py-2">
      <span className="font-bold ">{name}</span>
      <p className="px-4">{value}</p>
    </div>
  );
}
